// extracted by mini-css-extract-plugin
module.exports = {"icons":"CompareAreaWizard_icons__3Of7W"};